<template>
  <!-- 代理店登録ダイアログ -->
  <div>
    <v-btn class="info font-weight-bold" @click="showDialog"
      ><v-icon left>mdi-plus-box</v-icon
      ><span class="d-none d-sm-flex">新規登録</span
      ><span class="d-sm-none">新規</span></v-btn
    >
    <v-dialog
      v-model="dialog"
      scrollable
      persistent
      width="100%"
      max-width="800px"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">代理店設定</span>
        </v-card-title>
        <v-card-text class="scrollable-content">
          <input type="hidden" v-model="item.id" />
          <ValidationObserver ref="observer">
            <h3 id="title_head">基本情報</h3>
            <div class="mt-2 mb-2">代理店に関する情報を設定して下さい。</div>
            <v-container fluid>
              <v-row>
                <v-col cols="12" sm="6">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="代理店名"
                    rules="required|max:255"
                  >
                    <v-text-field
                      v-model="item.name"
                      name="name"
                      :error-messages="errors"
                      :success="valid"
                      label="代理店名"
                      hint="代理店名を入力してください[必須項目]"
                      persistent-hint
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="郵便番号"
                    rules="max:20"
                  >
                    <v-text-field
                      v-model="item.zip_code"
                      name="zip_code"
                      :error-messages="errors"
                      :success="valid"
                      label="郵便番号"
                      hint="郵便番号を入力してください"
                      persistent-hint
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="住所1"
                    rules="max:255"
                  >
                    <v-text-field
                      v-model="item.address1"
                      name="address1"
                      :error-messages="errors"
                      :success="valid"
                      label="住所1"
                      hint="都道府県・市区町村を入力してください"
                      persistent-hint
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="住所2"
                    rules="max:255"
                  >
                    <v-text-field
                      v-model="item.address2"
                      name="address2"
                      :error-messages="errors"
                      :success="valid"
                      label="住所2"
                      hint="番地・建物名等を入力してください"
                      persistent-hint
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="3">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="代表番号"
                    rules="max:50"
                  >
                    <v-text-field
                      v-model="item.tel"
                      name="tel"
                      :error-messages="errors"
                      :success="valid"
                      label="代表番号"
                      hint="代表電話番号を入力してください"
                      persistent-hint
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="ホームページ"
                    rules="max:500"
                  >
                    <v-text-field
                      v-model="item.website"
                      name="website"
                      :error-messages="errors"
                      :success="valid"
                      label="ホームページ"
                      hint="ホームページURLを入力してください"
                      persistent-hint
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="12">
                  <ValidationProvider
                    v-slot="{ errors, valid }"
                    name="メモ"
                    rules="max:1000"
                  >
                    <v-text-field
                      v-model="item.note"
                      name="note"
                      :error-messages="errors"
                      :success="valid"
                      label="メモ"
                      hint="代理店に関するメモを入力してください"
                      persistent-hint
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
        <v-card-actions>
          <v-container>
            <v-row justify="end">
              <v-col cols="6" sm="3">
                <general-button
                  btn_color="gray"
                  btn_block
                  @click-event="cancelDialog"
                  ><template v-slot:icon
                    ><v-icon left>mdi-close-circle</v-icon></template
                  >キャンセル</general-button
                >
              </v-col>
              <v-col cols="6" sm="3">
                <general-button
                  btn_type="info"
                  btn_block
                  @click-event="onSubmit"
                  ><template v-slot:icon
                    ><v-icon left>mdi-content-save</v-icon></template
                  >保存</general-button
                >
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { reactive, toRefs, defineComponent } from "@vue/composition-api";
import { repositoryFactory } from "@/repository/repositoryFactory";
import store from "@/store/index.js";
import setting from "@/common/setting.js";

export default defineComponent({
  setup(props, ctx) {
    const agenciesRepository = repositoryFactory.get("agencies");
    const state = reactive({
      dialog: false, // ダイアログ表示用
      item: {
        id: 0,
        name: "",
        zip_code: "",
        address1: "",
        address2: "",
        tel: "",
        website: "",
        note: "",
      },
    });

    // 新規作成
    const showDialog = async () => {
      await store.dispatch("loadingIcon/showIcon"); // ローディング表示

      // ダイアログ開く
      state.dialog = true;

      // ローディング非表示
      await store.dispatch("loadingIcon/hideIcon");
    };

    const clearDialog = async () => {
      // 各種項目初期化
      state.item.id = 0;
      state.item.name = "";
      state.item.zip_code = "";
      state.item.address1 = "";
      state.item.address2 = "";
      state.item.tel = "";
      state.item.website = "";
      state.item.note = "";
    };

    const editDialog = async (agencyId) => {
      await agenciesRepository
        .admin_get(agencyId)
        .then((response) => {
          if (response.data) {
            // データ取得OK
            state.item.id = response.data.id;
            state.item.name = response.data.name;
            state.item.zip_code = response.data.zip_code || "";
            state.item.address1 = response.data.address1 || "";
            state.item.address2 = response.data.address2 || "";
            state.item.tel = response.data.tel || "";
            state.item.website = response.data.website || "";
            state.item.note = response.data.note || "";
          }
        })
        .catch((error) => {
          throw (
            "ERROR:agencyDialogComponent.vue/editDialog agenciesRepository.admin_get (" +
            error +
            ")"
          );
        });
      state.dialog = true;
    };

    // 保存処理
    const onSubmit = async () => {
      // 入力チェック エラー状態の部品が無いか調べる
      const isValid = await ctx.refs.observer.validate();
      if (!isValid) {
        // エラー処理
        return;
      }

      if (!window.confirm("保存してよろしいですか？")) {
        return false;
      }
      // ローディング表示
      store.dispatch("loadingIcon/showIcon");

      // 保存処理
      const params = {
        id: state.item.id,
        name: state.item.name,
        zip_code: state.item.zip_code,
        address1: state.item.address1,
        address2: state.item.address2,
        tel: state.item.tel,
        website: state.item.website,
        note: state.item.note,
        is_active: true,
      };

      // 新規か更新か
      if (state.item.id == 0) {
        // 新規
        await agenciesRepository
          .admin_create(params)
          .then((response) => {
            if (response.data) {
              // データ追加OK
              state.item.id = response.data.id; // idをセット
              ctx.refs.observer.reset(); // 入力エラー表示クリア
            }
          })
          .catch((error) => {
            throw (
              "ERROR:agencyDialogComponent.vue/onSubmit agenciesRepository.admin_create (" +
              error +
              ")"
            );
          });
      } else {
        // 更新
        await agenciesRepository
          .admin_update(params)
          .then((response) => {
            if (response.data) {
              // データ更新OK
              ctx.refs.observer.reset(); // 入力エラー表示クリア
            }
          })
          .catch((error) => {
            throw (
              "ERROR:agencyDialogComponent.vue/onSubmit agenciesRepository.admin_update (" +
              error +
              ")"
            );
          });
      }

      // ローディング非表示
      store.dispatch("loadingIcon/hideIcon");

      cancelDialog();

      ctx.emit("updated", params);
    };

    // ダイアログキャンセルボタン
    const cancelDialog = () => {
      state.dialog = false;
      ctx.refs.observer.reset(); // 入力エラー表示クリア
      clearDialog();
    };

    const init = async () => {
      // 初期化
      clearDialog();
    };

    init();

    // 返却オブジェクト定義
    return {
      setting,
      ...toRefs(state),
      editDialog,
      onSubmit,
      cancelDialog,
      showDialog,
    };
  },
});
</script>

<style scoped></style>
